import PromoCodeInfo from '../../../PromoCodeInfo/PromoCodeInfo'
import { renderFreeTilesText } from '../../OrderSummaryUtils'
import { translateManager as t } from 'services/TranslateManager'
import { numberToText } from '../../../../../utils/utils'

export const getFreeCouponAction = ({ unused }) => {
  if (unused) {
    return unused > 1
      ? t.get('order.checkout.payment_summary_rows.can_add_free_tiles', {
          v1: numberToText(unused),
        })
      : t.get('order.checkout.payment_summary_rows.can_add_one_free_tile')
  }
}

export function PromoCodeInfoBox({ data, hasFreeTiles }) {
  const hasFreeCouponsAdditionalData =
    data.freeTilesData &&
    data.freeTilesData.tileCreditsData &&
    data.freeTilesData.tileCreditsData.length > 0
  return (
    <div className="PromoCodeBox">
      {hasFreeTiles &&
        hasFreeCouponsAdditionalData &&
        data.freeTilesData.tileCreditsData.map((credit, idx) => (
          <PromoCodeInfo
            key={`PromoCodeInfo-${idx}`}
            title={renderFreeTilesText({
              data,
              numOfTiles: credit.amount,
            })}
            subtitle={getFreeCouponAction({
              unused: credit.amount - credit.used,
            })}
            showIcon
          />
        ))}
      {hasFreeTiles && !hasFreeCouponsAdditionalData ? (
        <PromoCodeInfo
          title={renderFreeTilesText({
            data,
            numOfTiles: data.freeTilesData.freeTilesCreditTotal,
          })}
          subtitle={getFreeCouponAction({
            unused: data.unusedFreeTiles,
          })}
          showIcon
        />
      ) : null}
    </div>
  )
}
